import React, { useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Avatar,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { RandomReveal } from "react-random-reveal";

import { useGetFbProfileImage } from "../DataHooks/useGetFbProfileImage";

// Styled components
const StyledCard = styled(Card)(() => ({
  maxWidth: 345,
  border: "none",
  boxShadow: "none",
}));

const StyledMedia = styled(CardMedia)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const HiddenMedia = styled(Box)(() => ({
  display: "none",
}));

const MediaCard = (props) => {
  const { value } = props;
  const {
    from: { id, name = "?" },
  } = value;
  const [complete, setComplete] = useState(false);
  const fbProfileImageUrl = useGetFbProfileImage(id);

  return (
    <StyledCard>
      <CardActionArea>
        {complete ? (
          <StyledMedia>
            <Avatar src={fbProfileImageUrl} sx={{ width: 240, height: 240 }} />
          </StyledMedia>
        ) : (
          <HiddenMedia />
        )}
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="h2"
            textAlign="center"
          >
            <RandomReveal
              isPlaying
              duration={10}
              revealDuration={0.5}
              characters={name}
              onComplete={() => setComplete(true)}
            />
          </Typography>
        </CardContent>
      </CardActionArea>
    </StyledCard>
  );
};

export default MediaCard;
